import { IconButton, Stack, styled, Tooltip, tooltipClasses } from '@mui/material';
import { Add } from '@tempo-io/sui-icons';

const StyledHeader = styled(Stack)({
  height: '36px',
  lineHeight: '36px',
  borderTop: '1px solid #E0E0E0',
  textTransform: 'uppercase',
});

interface ISubItemHeader {
  count: number;
  onAdd: () => void;
  canAdd: boolean;
}

export function SubItemHeader({ count, onAdd, canAdd }: ISubItemHeader) {
  return (
    <StyledHeader direction="row" alignItems="center" justifyContent="space-between">
      <span className="text-xs font-semibold leading-3 text-text-neutral-secondary">
        {`SUB-ITEMS${count > 0 ? ` (${count})` : ''}`}
      </span>
      {count > 0 && canAdd && (
        <Tooltip
          title="Add Sub-Item"
          placement="top-end"
          slotProps={{
            popper: {
              sx: {
                [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: '4px',
                  },
              },
            },
          }}
        >
          <IconButton size="small" aria-label="Sub Items" onClick={onAdd} sx={{ padding: '2px' }}>
            <Add aria-label="add sub-item" />
          </IconButton>
        </Tooltip>
      )}
    </StyledHeader>
  );
}
